/**
 * APA-UX-041 / GH #6813 — homepage, nav, footer, education, order-plan (saved),
 * membership dashboard, and activation-verified emitters.
 * Canonical pma_* only; no PII; never blocks UI.
 */
(function () {
  "use strict";

  var TRUNCATE = 100;
  var ACTIVATION_SESSION_KEY = "pma_activation_verified_emitted";

  function track(name, payload, options) {
    try {
      if (window.PMAAnalytics && typeof window.PMAAnalytics.track === "function") {
        window.PMAAnalytics.track(name, payload || {}, options || { consent_class: "analytics" });
        return;
      }
      if (window.PMA && window.PMA.analytics && typeof window.PMA.analytics.track === "function") {
        window.PMA.analytics.track(name, payload || {}, options || { consent_class: "analytics" });
      }
    } catch (_) {}
  }

  function truncate(v) {
    var s = v == null ? "" : String(v);
    return s.length > TRUNCATE ? s.slice(0, TRUNCATE) : s;
  }

  function pathOnly(href) {
    if (!href) return "";
    try {
      return new URL(String(href), window.location.origin).pathname || "/";
    } catch (_) {
      return String(href).split("?")[0].split("#")[0].slice(0, TRUNCATE);
    }
  }

  function pageType() {
    try {
      var ctx = window.PMA_Analytics_Context || {};
      if (ctx.page_type) return String(ctx.page_type);
    } catch (_) {}
    var p = (window.location && window.location.pathname) || "";
    if (p === "/" || p === "") return "index";
    if (p.indexOf("/pages/education") === 0 || p.indexOf("/blogs/") === 0) return "education";
    if (p.indexOf("/pages/member-dashboard") === 0) return "member_dashboard";
    if (p.indexOf("/account") === 0) return "account";
    return "page";
  }

  function isIndex() {
    var p = (window.location && window.location.pathname) || "";
    return p === "/" || p === "" || pageType() === "index";
  }

  function isEducationSurface() {
    var p = (window.location && window.location.pathname) || "";
    var t = pageType();
    return (
      t === "education" ||
      p.indexOf("/pages/education") === 0 ||
      p.indexOf("/blogs/") === 0 ||
      !!document.querySelector(
        "[data-section-handle='pma__content__education_library_home'], [data-section-handle='pma__content__education_section_index'], [data-section-handle='pma__content__education_template']"
      )
    );
  }

  function isDashboardSurface() {
    var p = (window.location && window.location.pathname) || "";
    var t = pageType();
    return (
      t === "member_dashboard" ||
      t === "account" ||
      p.indexOf("/pages/member-dashboard") === 0 ||
      p.indexOf("/account") === 0
    );
  }

  function firePageSurfaces() {
    if (isIndex()) {
      track("pma_homepage_view", { surface: "homepage" }, { once_per_page: true, consent_class: "analytics" });
    }
    if (isEducationSurface()) {
      track(
        "pma_education_hub_view",
        { surface: "education", route: truncate((window.location && window.location.pathname) || "") },
        { once_per_page: true, consent_class: "analytics" }
      );
    }
    if (isDashboardSurface()) {
      track(
        "pma_membership_dashboard_view",
        { surface: pageType() || "account" },
        { once_per_page: true, consent_class: "analytics" }
      );
      if (document.querySelector("[data-section-handle='pma__account__membership_status_anchor'], .pma-account-membership-status, [data-pma-membership-status]")) {
        track(
          "pma_membership_status_card_view",
          { surface: pageType() || "account" },
          { once_per_page: true, consent_class: "analytics" }
        );
      }
      if (document.querySelector("[data-pma-progress-step], .pma-membership-progress, [data-section-handle*='progress']")) {
        track(
          "pma_membership_progress_step_view",
          { surface: pageType() || "account" },
          { once_per_page: true, consent_class: "analytics" }
        );
      }
      if (document.querySelector("[data-pma-saved-products-root], #saved-products")) {
        track(
          "pma_order_plan_view",
          { surface: "saved_products", cart_state: document.body.classList.contains("is-member-active") ? "active" : "locked" },
          { once_per_page: true, consent_class: "analytics" }
        );
      }
    }

    // active_unlock_confirmed → pma_membership_activation_verified (once per session when active)
    if (document.body && document.body.classList.contains("is-member-active")) {
      try {
        if (!sessionStorage.getItem(ACTIVATION_SESSION_KEY)) {
          track(
            "pma_membership_activation_verified",
            {
              verification_method: "liquid_body_class_active",
              member_state_post: "active"
            },
            { once_per_page: true, consent_class: "analytics" }
          );
          sessionStorage.setItem(ACTIVATION_SESSION_KEY, "1");
        }
      } catch (_) {
        track(
          "pma_membership_activation_verified",
          { verification_method: "liquid_body_class_active", member_state_post: "active" },
          { once_per_page: true, consent_class: "analytics" }
        );
      }
    }
  }

  function classifyHomeCta(el) {
    var cta = (el.getAttribute("data-pma-cta") || "").toLowerCase();
    var href = pathOnly(el.getAttribute("href") || "");
    var text = truncate(el.textContent || "").toLowerCase();
    if (cta === "home_hero_primary" || cta === "home_hero_browse") return "primary";
    if (cta === "home_hero_secondary" || cta === "home_hero_account") return "secondary";
    if (cta.indexOf("home_hero") === 0) return "secondary";
    if (el.classList.contains("pma-hero__tertiary") || href.indexOf("/pages/how-it-works") === 0) return "how_it_works";
    if (/activate/.test(text) || href.indexOf("billing") !== -1 || href.indexOf("activate") !== -1) return "activate";
    return "secondary";
  }

  function initDelegatedClicks() {
    document.addEventListener(
      "click",
      function (event) {
        var t = event.target && event.target.closest && event.target.closest("a, button");
        if (!t) return;
        var href = pathOnly(t.getAttribute("href") || "");
        var surface = truncate(t.getAttribute("data-pma-cta-surface") || "");

        // Homepage CTAs
        if (isIndex() && (t.closest(".pma-hero") || (t.getAttribute("data-pma-cta") || "").indexOf("home_hero") === 0)) {
          var kind = classifyHomeCta(t);
          if (kind === "primary") {
            track("pma_homepage_primary_cta_click", { surface: surface || "home_hero", destination: href });
          } else if (kind === "how_it_works") {
            track("pma_homepage_how_it_works_click", { surface: surface || "home_hero", destination: href });
          } else if (kind === "activate") {
            track("pma_activate_membership_click", { surface: surface || "home_hero", destination: href });
            track("pma_homepage_primary_cta_click", { surface: surface || "home_hero", destination: href, cta_intent: "activate" });
          } else {
            track("pma_homepage_secondary_cta_click", { surface: surface || "home_hero", destination: href });
          }
        }

        // Homepage category / producer modules
        if (isIndex()) {
          if (t.closest("[data-section-handle='pma__commerce__product_grid'], .pma-collection-card, [data-pma-category-card]")) {
            track("pma_homepage_category_click", { surface: "homepage_category", destination: href, item_id: truncate(t.getAttribute("data-collection-handle") || href) });
          }
          if (t.closest("[data-section-handle*='producer'], [data-producer-attribution], .pma-producer-card")) {
            track("pma_homepage_producer_module_click", { surface: "homepage_producer", destination: href, producer_id: truncate(t.getAttribute("data-producer-handle") || "") });
          }
        }

        // Primary nav
        if (t.matches("[data-pma-nav-area='primary']") || t.closest("[data-pma-nav-area='primary']")) {
          var navEl = t.matches("[data-pma-nav-area='primary']") ? t : t.closest("[data-pma-nav-area='primary']");
          track("pma_nav_primary_click", {
            surface: "header_primary",
            destination: pathOnly(navEl.getAttribute("href") || href),
            label: truncate(navEl.textContent || "")
          });
        }

        // Footer links
        if (t.closest(".pma-footer a")) {
          track("pma_footer_link_click", {
            surface: "footer",
            destination: href,
            label: truncate(t.textContent || "")
          });
        }

        // Lock panel how-it-works
        if (
          (t.closest(".pma-lock, [data-pma-lock], .pma-locked-only") || surface.indexOf("lock") !== -1) &&
          href.indexOf("/pages/how-it-works") === 0
        ) {
          track("pma_lock_panel_how_it_works_click", { surface: surface || "lock_panel", destination: href });
        }

        // FAQ recovery / support routing
        if (t.closest("[data-section-handle*='faq'], .pma-faq") || href.indexOf("/pages/faq") === 0) {
          if (href.indexOf("/pages/contact") === 0 || href.indexOf("/pages/support") === 0 || href.indexOf("/pages/how-it-works") === 0) {
            track("pma_faq_recovery_link_click", { surface: "faq", destination: href });
          }
        }
        if (
          (t.getAttribute("data-pma-cta") || "").indexOf("support") === 0 ||
          href.indexOf("/pages/support") === 0 ||
          href.indexOf("/pages/contact") === 0
        ) {
          if (t.closest(".pma-header, .pma-footer, .pma-lock, [data-pma-lock]")) {
            track("pma_support_routing_click", { surface: surface || "support_routing", destination: href });
          }
        }

        // Dashboard next-action / support / activate
        if (isDashboardSurface()) {
          if (t.matches("[data-pma-next-action], [data-pma-membership-next-action]") || /activate|continue|apply|status/i.test(t.textContent || "")) {
            if (/activate/i.test(t.textContent || "") || href.indexOf("billing") !== -1) {
              track("pma_activate_membership_click", { surface: pageType(), destination: href });
            }
            track("pma_membership_next_action_click", { surface: pageType(), destination: href, label: truncate(t.textContent || "") });
          }
          if (href.indexOf("/pages/support") === 0 || href.indexOf("/pages/contact") === 0) {
            track("pma_membership_support_click", { surface: pageType(), destination: href });
          }
          if (href.indexOf("/pages/shop") === 0 || href.indexOf("/collections") === 0) {
            track("pma_order_plan_continue_browsing_click", { surface: "saved_products", destination: href });
          }
          if (/apply/i.test(t.textContent || "") || href.indexOf("become-a-member") !== -1 || href.indexOf("join") !== -1) {
            track("pma_order_plan_apply_click", { surface: "saved_products", destination: href });
          }
          if (/status|application/i.test(t.textContent || "") || href.indexOf("member-dashboard") !== -1) {
            track("pma_order_plan_status_click", { surface: "saved_products", destination: href });
          }
        }

        // Education clicks
        if (isEducationSurface() || t.closest("[data-section-handle*='education']")) {
          if (t.closest("[data-education-topic], .pma-education-topic")) {
            track("pma_education_topic_click", { surface: "education", destination: href });
          } else if (t.closest("article, .pma-article-card, [data-education-guide]")) {
            track("pma_education_guide_click", { surface: "education", destination: href });
          } else if (href.indexOf("/pages/support") === 0 || href.indexOf("/pages/contact") === 0) {
            track("pma_education_support_click", { surface: "education", destination: href });
          }
        }
      },
      false
    );
  }

  function initOrderPlanConvertHooks() {
    // Saved-products → cart convert attempts (when UI exposes convert controls).
    document.addEventListener(
      "click",
      function (event) {
        var btn = event.target && event.target.closest && event.target.closest("[data-pma-order-plan-convert], [data-pma-saved-convert-to-cart]");
        if (!btn) return;
        var active = document.body && document.body.classList.contains("is-member-active");
        track("pma_order_plan_convert_to_cart_attempt", {
          surface: "saved_products",
          cart_state: active ? "active" : "locked"
        });
        if (!active) {
          track("pma_order_plan_convert_to_cart_blocked", {
            surface: "saved_products",
            block_reason: "membership_required",
            cart_state: "locked"
          });
        } else {
          track("pma_order_plan_convert_to_cart_success", {
            surface: "saved_products",
            cart_state: "active"
          });
        }
      },
      false
    );
  }

  function boot() {
    firePageSurfaces();
    initDelegatedClicks();
    initOrderPlanConvertHooks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Re-fire page surfaces when harness re-invokes firePageView (pending persona inject).
  document.addEventListener("pma:analytics", function (ev) {
    try {
      var name = ev && ev.detail && ev.detail.event;
      if (name === "pma_page_view") {
        // soft re-check activation only
        if (document.body && document.body.classList.contains("is-member-active")) {
          try {
            if (!sessionStorage.getItem(ACTIVATION_SESSION_KEY)) {
              track("pma_membership_activation_verified", {
                verification_method: "liquid_body_class_active",
                member_state_post: "active"
              });
              sessionStorage.setItem(ACTIVATION_SESSION_KEY, "1");
            }
          } catch (_) {}
        }
      }
    } catch (_) {}
  });
})();
